module.exports = __webpack_public_path__ + "img/Icon_Checkmark_Active.0501e61c.svg";